import { render, staticRenderFns } from "./Girl.vue?vue&type=template&id=21a7cb69&scoped=true&"
import script from "./Girl.vue?vue&type=script&lang=ts&"
export * from "./Girl.vue?vue&type=script&lang=ts&"
import style0 from "./Girl.vue?vue&type=style&index=0&id=21a7cb69&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a7cb69",
  null
  
)

export default component.exports